export default __webpack_public_path__ + "static/media/kargil2.925bd4c4.jpg";